'use strict';

import * as domUtils from '../../util/dom';
var timeUtils = require('../../util/time');
var Debug = require('../../util/debug')('play-button');
var Sizzle = require('sizzle');
import * as Constants from './ui-constants';
var PLAYING_STATE = Constants.PLAYING_STATE;
var PROPERTY_CLASS = Constants.PROPERTY_CLASS;

var NAMESPACE = 'ui-play-button';

var CLASSNAMES = {
	buttonContainer: 'svp_ui-controls__playButton-container',
	buttonLabel: 'svp_ui-controls__playButton-label',
	errorMarker: 'svp_js-controls-btn--play__error-marker',
	play: 'svp_js-controls-btn--play'
};

var BUTTON_ICONS = {
	general_error: 'svp_ui-controls__button-general-error',
	geoblock_error: 'svp_ui-controls__button-geoblock-error',
	liveNotStarted_error: 'svp_ui-controls__button-live-not-started-error',
	play: 'svp_ui-controls__button-play',
	pause: 'svp_ui-controls__button-pause',
	stop: 'svp_ui-controls__button-stop'
};


var createFn = function (api) {
	var _currentState = PLAYING_STATE.unknown,
		_prevState = null,
		_isLiveVideo = false,
		_isTimeshiftEnabled = false,
		_isVideoError = false,
		_liveStartTimeUTC = 0;

	function _getElement(className) {
		return api && Sizzle('.' + className, api.element())[0];
	}

	function _getPlayButton() {
		return _getElement(CLASSNAMES.play);
	}

	function _setPlayingState(state) {
		Debug('Setting state to ' + state);
		var playButton = _getPlayButton(),
			playButtonLabel = _getElement(CLASSNAMES.buttonLabel),
			spaceEnabled = false,
			assertive = false,
			label;

        if (state !== PLAYING_STATE.loading) {
		    domUtils.removeClass(playButton, [BUTTON_ICONS.play, BUTTON_ICONS.general_error, BUTTON_ICONS.geoblock_error,
			    BUTTON_ICONS.pause, BUTTON_ICONS.stop, BUTTON_ICONS.liveNotStarted_error]);
        }

		switch(state) {
			case PLAYING_STATE.playing:
				if (_isLiveVideo && !_isTimeshiftEnabled) {
					domUtils.addClass(playButton, BUTTON_ICONS.stop);
					label = 'Stoppa video';
				} else {
					domUtils.addClass(playButton, BUTTON_ICONS.pause);
					label = 'Pausa video';
				}
				spaceEnabled = true;
				_isVideoError = false;
				break;
			case PLAYING_STATE.paused:
				domUtils.addClass(playButton, BUTTON_ICONS.play);
				label = 'Spela video';
				spaceEnabled = true;
				break;
			case PLAYING_STATE.loading:
				label = 'Laddar video';
				assertive = true;
				_isVideoError = false;
				break;
			case PLAYING_STATE.error:
				var errorClass = BUTTON_ICONS.general_error;
				domUtils.addClass(playButton, errorClass);
				label = 'Fel';
				_isVideoError = true;
				break;
		}

		playButton.setAttribute('tabindex', _isVideoError ? '-1' : '0');
		playButton.setAttribute('aria-live', assertive ? 'assertive' : 'off');
		playButtonLabel.innerHTML = label + (state === PLAYING_STATE.loading ? ' ' + timeUtils.getFormattedTime(api.getCurrentTime()) : '');

		domUtils.forceRedraw(playButton);

		_currentState = state;
		if (state !== PLAYING_STATE.loading) {
			_prevState = state;
		}
	}

	api.on(NAMESPACE + '.metadata', function (data) {
		_isLiveVideo = data && (data.detail.live || data.detail.simulcast);
		_isTimeshiftEnabled = data && data.detail.timeshiftEnabled;
		_liveStartTimeUTC = data && data.detail.liveStartTimeUTC;
	});

	var togglePlayFn = function (e) {
		if (e) {
			e.preventDefault();
			e.stopPropagation();
		}

		switch (_currentState) {
			case PLAYING_STATE.paused:
				if (_isLiveVideo && !_isTimeshiftEnabled) {
					api.seek(Number.POSITIVE_INFINITY);
				}
				api.play();
				break;
			case PLAYING_STATE.playing:
				api.pause();
				break;
			default:
				// Do nothing
				break;
		}
	};

	return {

		createElement: function () {
			return domUtils.fromString(
				'<div class=" ' + PROPERTY_CLASS.controlsHideInitially + ' ' + CLASSNAMES.buttonContainer + '">\
					<button class="' + CLASSNAMES.play + ' ' + BUTTON_ICONS.play + '"\
						aria-live="off"\
						tabindex="0"\
						data-rt="video-player-play">\
						<span class="svp_ui-controls__hidden ' + CLASSNAMES.buttonLabel + '">Laddar video</span>\
					</button>\
				</div>');
		},

		bindEvents: function (api) {
			var setLoading = _setPlayingState.bind(this, PLAYING_STATE.loading);

			api.on(NAMESPACE + '.play', function () {
				domUtils.removeClass(_getElement(CLASSNAMES.buttonContainer), 'svp_ui-controls--hide-initial');
				setLoading();
			});

			api.on(NAMESPACE + '.buffering', setLoading);
			api.on(NAMESPACE + '.seeking', setLoading);
			api.on(NAMESPACE + '.loadstart', setLoading);

			api.on(NAMESPACE + '.seeked', function () {
				_setPlayingState(_prevState);
			});

			api.on(NAMESPACE + '.canplay', function () {
				_setPlayingState(PLAYING_STATE.paused);
			});

			api.on(NAMESPACE + '.playing', function () {
				_setPlayingState(PLAYING_STATE.playing);
			});

			api.on(NAMESPACE + '.pause', function () {
				_setPlayingState(PLAYING_STATE.paused);
			});

			api.on(NAMESPACE + '.timeupdate', () => {
				if (api.video().paused === false) {
					_setPlayingState(PLAYING_STATE.playing);
				}
			});

			api.on(NAMESPACE + '.ui-error', function (errorEvent) {
				var retry = errorEvent && errorEvent.detail ? errorEvent.detail.retry : false;
				_setPlayingState(retry ? PLAYING_STATE.PAUSED : PLAYING_STATE.ERROR);
			});

			domUtils.addEvents(_getPlayButton(), 'mousedown', function (e) {
				e.preventDefault();
			});
			domUtils.addEvents(_getPlayButton(), 'click, touchend', togglePlayFn);
			domUtils.addEvents(_getPlayButton(), 'keyup',function (e) {
				if (domUtils.getKeyFromKeyEvent(e) === 'enter') {
					e.stopPropagation();
				}
			}, NAMESPACE);
		},
		setState: function (state, what) {
			if (state === 'error') {
				_setPlayingState(PLAYING_STATE.error, what);
			}
		},
		togglePlay: togglePlayFn,
		reset: function () {
			_currentState = PLAYING_STATE.unknown;
			var playButton = _getPlayButton(),
				errorElements = Sizzle('.' + CLASSNAMES.errorMarker, playButton);

			errorElements.forEach(function (el) {
				playButton.removeChild(el);
			});
		}
	};

};

module.exports = {
	create: createFn,

	destroy: function (api) {
		api.off(NAMESPACE + '.pause');
		api.off(NAMESPACE + '.play');
		api.off(NAMESPACE + '.playing');
		api.off(NAMESPACE + '.seeking');
		api.off(NAMESPACE + '.seeked');
		api.off(NAMESPACE + '.buffering');
		api.off(NAMESPACE + '.canplay');
		api.off(NAMESPACE + '.metadata');
		api.off(NAMESPACE + '.ui-error');

		var playButton = Sizzle('.' + CLASSNAMES.play, api.element())[0];
		if (playButton) {
			domUtils.removeEvents(playButton, 'click, touchend, keyup', NAMESPACE);
			playButton.parentElement.removeChild(playButton);
		}
	}
};



// WEBPACK FOOTER //
// ./src/js/plugins/ui/play-button.js